import * as defaultImport from "@splunk/react-icons/ChevronUp";
export * from "@splunk/react-icons/ChevronUp";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
